import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import qs from 'query-string';

import SlidesSection from './components/SlidesSection';
import UploadIcon from '../../../../../../../components/icons/UploadIcon';
import Button from '../../../../../../../components/global/Button';
import { ALBUM_SUBTYPE } from '../../../../../../../constants/albums';
import { VIDEO_TYPE } from '../../../../../../../constants/videos';

const propTypes = {
  visible: PropTypes.bool,
  albumId: PropTypes.string,
  albumSubtype: PropTypes.oneOf(Object.values(ALBUM_SUBTYPE)),
  currentVideoId: PropTypes.string.isRequired,
  slideshowVideos: PropTypes.array.isRequired,
  videosTotal: PropTypes.number.isRequired,
  videosOffset: PropTypes.number.isRequired,
  loadingMore: PropTypes.bool.isRequired,
  onLoadMore: PropTypes.func.isRequired,
  onMoveVideo: PropTypes.func.isRequired,
  onReorderVideos: PropTypes.func.isRequired,
  onDeleteVideo: PropTypes.func.isRequired,
  onThumbnailClick: PropTypes.func.isRequired,
  isPlaying: PropTypes.bool.isRequired,
  hasUnprocessedVideos: PropTypes.bool.isRequired,
};

const SecondaryVideosView = ({
  visible,
  albumId,
  albumSubtype,
  currentVideoId,
  slideshowVideos,
  videosTotal,
  videosOffset,
  loadingMore,
  onLoadMore,
  onMoveVideo,
  onReorderVideos,
  onDeleteVideo,
  onThumbnailClick,
  isPlaying,
  hasUnprocessedVideos,
}) => {
  const location = useLocation();

  if (!visible) {
    return null;
  }

  const uploadLabel = (() => {
    if (
      albumSubtype === ALBUM_SUBTYPE.WEDDINGS &&
      !!slideshowVideos?.find(({ video }) => video.type === VIDEO_TYPE.GREETING)
    ) {
      return 'Edit greeting';
    }

    if (albumSubtype === ALBUM_SUBTYPE.WEDDINGS) {
      return 'Add a greeting';
    }

    return 'Upload videos';
  })();

  return (
    <div className="secondary-photos-view-container">
      <Button
        btnStyle="reset"
        className="secondary-photos-view-photos-step-upload"
        to={{
          pathname: `/contributors/upload/${albumId}/record-video`,
          search: `?${qs.stringify({
            next: location.pathname,
          })}`,
        }}
      >
        <UploadIcon size={12} color="#0d84fe" className="mr-1" /> {uploadLabel}
      </Button>
      <SlidesSection
        videosTotal={videosTotal}
        videosOffset={videosOffset}
        currentVideoId={currentVideoId}
        loadingMore={loadingMore}
        onLoadMore={onLoadMore}
        onDeleteVideo={onDeleteVideo}
        slideshowVideos={slideshowVideos}
        onMoveVideo={onMoveVideo}
        onReorderVideos={onReorderVideos}
        onThumbnailClick={onThumbnailClick}
        isPlaying={isPlaying}
        hasUnprocessedVideos={hasUnprocessedVideos}
      />
    </div>
  );
};

SecondaryVideosView.propTypes = propTypes;

export default SecondaryVideosView;
